import React, { useEffect, useRef } from 'react'
import SuccessImage from "../assets/images/Completed-pana 1.png";
import { useNavigate, useSearchParams } from 'react-router-dom';
const SuccessRegPage = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const isMNP = searchParams.get('isMNP')
    const dealerSavedData = sessionStorage.getItem('dealerRegisterForm');
    const mnpSavedData = sessionStorage.getItem('mnpRegisterForm');
    const savedData = isMNP ? mnpSavedData || dealerSavedData : dealerSavedData || mnpSavedData;
    const hasSavedData = Boolean(dealerSavedData || mnpSavedData);
    const hasRedirected = useRef(false);

    useEffect(() => {
        if (!hasSavedData && !hasRedirected.current) {
            hasRedirected.current = true;
            if (window.history.length > 1) {
                navigate(-1);
            } else {
                navigate('/home', { replace: true });
            }
        }
    }, [hasSavedData, navigate]);

    const formData = JSON.parse(savedData);
    const currentTime = new Date().toLocaleString('sv-SE').slice(0, 16);
    // console.log('Full Name:', formData.full_name);
    // console.log('ICCID:', formData.iccid);
    // console.log('MSISDN:', formData.msisdn);

    if (!hasSavedData) return null;

    return (
        <div className='bg-accent-grey-50 h-screen lg:w-[450px] w-full mx-auto'>
            <div className="w-full">
                <div className="p-[34px]">
                    <img src={SuccessImage} alt="success" className="w-full h-full" />
                </div>

            </div>
            <div className=' px-[50px] flex flex-col justify-center items-center'>
                <p className='text-[#080808] text-[20px] font-[600]'>{isMNP ? "Submitted Successfully" : "Registered Successfully" }</p>
                {formData?.full_name && <p className='mt-1 text-[#757575] text-[16px] font-[500]'>{formData?.full_name}</p>}
                <p className='mt-1 text-[#757575] text-[16px] font-[500]'>{isMNP ? "Port-in request is being processed" : "Welcome to S4S Family."}</p>
            </div>
            <div className='mt-[80px] px-[16px] w-full flex flex-col'>
                <div className='flex justify-between'>
                    <p className='text-[#080808] text-[14px] font-[500]'>Date & Timestamp:</p>
                    <p className='text-[#757575] text-[16px] font-[400]'>{currentTime}</p>
                </div>
                {formData?.iccid && <div className='flex justify-between'>
                    <p className='text-[#080808] text-[14px] font-[500]'>ICCID#</p>
                    <p className='text-[#757575] text-[16px] font-[400]'>{formData?.iccid}</p>
                </div>}
                {formData?.msisdn && <div className='flex justify-between'>
                    <p className='text-[#080808] text-[14px] font-[500]'>MSISDN#</p>
                    <p className='text-[#757575] text-[16px] font-[400]'>{formData?.msisdn}</p>
                </div>}
            </div>
            <div className='w-full mt-[16px] px-[16px] pb-4'>
                <button onClick={() => {
                    sessionStorage.removeItem('dealerRegisterForm');
                    sessionStorage.removeItem('mnpRegisterForm');
                    navigate("/home");
                }} className='bg-primary text-white w-full rounded-full py-3'>Done</button>
            </div>
        </div>
    )
}

export default SuccessRegPage
